import { ClientPage } from "../../submodules/rapdv/client/elements/PagesCtrl"
import { CopyText } from "../elements/CopyText"

export class PageStorePrinter implements ClientPage {

  private static readonly COPIED_FEEDBACK_MS = 1500

  getPageId = (): string => "printer-details"

  execute = (): void => {
    const copyButton = document.querySelector("[data-copy-url]") as HTMLElement | null
    if (!copyButton) return

    copyButton.addEventListener("click", () => {
      CopyText.toClipboard(copyButton.dataset.copyUrl)

      const icon = copyButton.querySelector("i")
      if (!icon) return
      const originalClassName = icon.className
      icon.className = "bi bi-check-lg"
      window.setTimeout(() => { icon.className = originalClassName }, PageStorePrinter.COPIED_FEEDBACK_MS)
    })
  }

  onPageClose = (): void => {}
}
